import React from "react";

const GalleryImageField = props => {
    const componentClassname = "gallery-image__field";

    const hasErrors =
        !props.hideErrors &&
        props.errors &&
        props.showErrors &&
        props.errors.length;

    return (
        <div
            className={`${componentClassname}
				${componentClassname}--${props.type}
				${props.classes.inheritedClasses}
				${props.classes.isDisabled}
				${props.classes.isIncomplete}
				${props.classes.isFocused}
				${props.classes.hasValue}
				${props.classes.isValid}
                ${props.classes.isInvalid}
                ${props.checked ? "is-checked" : ""}
                ${hasErrors ? "is-invalid" : ""}
			`}
        >
            {/*label*/}
            <div className={`${componentClassname}__input-container`}>
                {/*input element*/}
                {React.cloneElement(props.inputElement, {
                    "aria-labelledby": props.label
                        ? props.accessibilityIds.label
                        : null,
                    "aria-describedby": props.info
                        ? props.accessibilityIds.description
                        : null,
                })}
            </div>
            <label htmlFor={props.accessibilityIds.input}>
                <div className={`${componentClassname}__field-container`}>
                    <span
                        href="#"
                        className={`${componentClassname}__browse-button`}
                    >
                        Browse
                    </span>
                </div>
                <span className={`${componentClassname}__filename`}>
                    {props.defaultImage ||
                        props.file.name ||
                        "No file selected"}
                </span>
                {(props.file.name || props.defaultImage) && (
                    <img
                        className={`${componentClassname}__preview`}
                        src={
                            props.defaultImage ||
                            URL.createObjectURL(props.file)
                        }
                        alt={"can't load"}
                    />
                )}
                {(props.file.name || props.defaultImage) && (
                    <button
                        type="button"
                        onClick={event => {
                            event.preventDefault();
                            props.onChange({
                                target: { files: [], name: props.name },
                            });
                            document.getElementById(
                                props.accessibilityIds.input
                            ).value = "";
                        }}
                        className={`${componentClassname}__delete-button icon icon-close`}
                    ></button>
                )}
            </label>
            {/*errors*/}
            {hasErrors ? (
                <div className={`${componentClassname}__errors`}>
                    <div
                        className={`${componentClassname}__errors__item`}
                        id={props.accessibilityIds.error}
                    >
                        Error: {props.errors[0]}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default GalleryImageField;
